var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor",attrs:{"id":"nivel"}},[_c('Sidebar'),_c('v-container',{staticClass:"level text-center ma-0 px-0 pt-6 pb-0",attrs:{"fluid":""}},[_c('v-row',{})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }